import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMessage/useStreamStall.ts
import { useEffect, useState } from "react";
import { preprocessStreamingContent } from "../ChatMarkdown/streamingAnimation.mjs";
var STREAM_STALL_MS = 1e3;
function showsOwnProgress(item) {
  switch (item?.type) {
    case "thinking":
      return true;
    case "content":
      return preprocessStreamingContent(item.content).trim() === "";
    case "tool":
      return item.status === "running";
    case "product_list":
    case "order_status":
      return Boolean(item.loading);
    case "clarifying_questions":
      return item.total !== void 0 && item.questions.length < item.total;
    case "pending_action":
      return item.outcome === void 0;
    default:
      return false;
  }
}
function useStreamStall(timeline, live, delay = STREAM_STALL_MS) {
  const [stalledAt, setStalledAt] = useState(void 0);
  useEffect(() => {
    if (!live || !timeline) return;
    const timer = setTimeout(setStalledAt, delay, timeline);
    return () => clearTimeout(timer);
  }, [timeline, live, delay]);
  return live && timeline !== void 0 && stalledAt === timeline;
}
export {
  STREAM_STALL_MS,
  showsOwnProgress,
  useStreamStall
};
//# sourceMappingURL=useStreamStall.mjs.map